import type { ReactNode, RefObject } from "react";
import { SelectField } from "../../ui/select-field.js";
import { disabledInp, Field, FieldGrid, CollapsibleSection } from "../sectionShared.js";

type InputProps = { value: string; onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void; disabled?: boolean; style: React.CSSProperties };

interface Props {
  sectionRef: RefObject<HTMLDivElement>;
  canView: (field: string) => boolean;
  inputProps: (field: string, value: string, onChange: (v: string) => void) => InputProps;
  pendingBadge: (field: string) => ReactNode;
  title: string; setTitle: (v: string) => void;
  firstName: string; setFirstName: (v: string) => void;
  middleName: string; setMiddleName: (v: string) => void;
  lastName: string; setLastName: (v: string) => void;
  email: string;
  employeeCode: string;
}

export function IdentitySection({
  sectionRef, canView, inputProps, pendingBadge,
  title, setTitle, firstName, setFirstName, middleName, setMiddleName, lastName, setLastName,
  email, employeeCode,
}: Props) {
  return (
    <CollapsibleSection id="identity" sectionRef={sectionRef} title="Identity">
      <FieldGrid cols="auto" gap="md">
        {canView("title") && (
          <Field label="Title">
            <SelectField {...inputProps("title", title, setTitle)}>
              <option value="">—</option>
              {["Mr", "Ms", "Mrs", "Dr", "Prof"].map((t) => <option key={t} value={t}>{t}</option>)}
            </SelectField>
          </Field>
        )}
        {canView("firstName") && (
          <Field label="First Name *">
            <input {...inputProps("firstName", firstName, setFirstName)} />
            {pendingBadge("firstName")}
          </Field>
        )}
        <Field label="Middle Name">
          <input {...inputProps("middleName", middleName, setMiddleName)} placeholder="Optional" />
        </Field>
        {canView("lastName") && (
          <Field label="Last Name *">
            <input {...inputProps("lastName", lastName, setLastName)} />
            {pendingBadge("lastName")}
          </Field>
        )}
        {canView("email") && (
          <Field label="Work Email">
            <input type="email" value={email} disabled style={disabledInp} />
          </Field>
        )}
      </FieldGrid>
      {employeeCode && (
        <div style={{ marginTop: 12, fontSize: 12, color: "var(--color-surface-400)" }}>
          Employee Code: <span className="break-all" style={{ fontFamily: "monospace", fontWeight: 600 }}>{employeeCode}</span>
        </div>
      )}
    </CollapsibleSection>
  );
}
